import React from 'react'
import { Modal, ModalBody, ModalTitle,ModalFooter } from '@vds/modals';
import { Body } from '@vds/typography';
import { MarginSpacerL, MarginSpacerM } from '../Checkout/styleTag';
import { Button } from '@vds/buttons';

export const SaveCartForDigital=({cartId="",opened=false,onOpenedChange=()=>{},closeModal=()=>{}})=>{
    return(
    <Modal opened={opened} onOpenedChange={onOpenedChange} id="digital-cart" disableOutsideClick={true} disableFocusLock= {true} >
        <ModalTitle>Customer's cart will be active for (20) days.</ModalTitle>
        <ModalBody> 
            <Body size="medium" bold>Cart ID: {cartId}</Body>
            <MarginSpacerM/>
            <Body size="medium">If you need to reference an order please save this Cart ID and provide if necessary.</Body>
            <MarginSpacerM/>
            <Body size="medium">Promos, pricing, and availability in your customer's cart might change by the time they return. 
                Check with the customer to ensure they complete the cart and don't have any questions.</Body>
            <MarginSpacerL/>
        <Button onClick={e => { closeModal() }} >Close</Button>
        </ModalBody>
    </Modal>
    )
}